import { render, staticRenderFns } from "./AiAccessNotice.vue?vue&type=template&id=9fd5a096&scoped=true"
import script from "./AiAccessNotice.vue?vue&type=script&lang=js"
export * from "./AiAccessNotice.vue?vue&type=script&lang=js"
import style0 from "./AiAccessNotice.vue?vue&type=style&index=0&id=9fd5a096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd5a096",
  null
  
)

export default component.exports